import React from "react";
import PropTypes from "prop-types";
import { Sun, CloudSun, Moon, SunMoon } from "lucide-react";

import { TabSetsLevels } from "../../../../../ui";

const SHIFT_ICONS = {
  fulltime: SunMoon,
  morning: Sun,
  afternoon: CloudSun,
  night: Moon,
};

const EventPayrollBulkShiftTabs = ({ shifts, activeShift, onChange, labels }) => (
  <TabSetsLevels
    className="event-payroll-generate__shift-tabs"
    size="sm"
    tabs={shifts.map((shift) => {
      const ShiftIcon = SHIFT_ICONS[shift];
      return {
        value: shift,
        label: <span className="text-label-sm">{labels[shift]}</span>,
        icon: <ShiftIcon size={14} />,
      };
    })}
    value={activeShift}
    onChange={onChange}
  />
);

EventPayrollBulkShiftTabs.propTypes = {
  shifts: PropTypes.arrayOf(
    PropTypes.oneOf(["fulltime", "morning", "afternoon", "night"]),
  ).isRequired,
  activeShift: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  labels: PropTypes.shape({
    fulltime: PropTypes.string,
    morning: PropTypes.string,
    afternoon: PropTypes.string,
    night: PropTypes.string,
  }).isRequired,
};

export default EventPayrollBulkShiftTabs;
